import React from "react";
import {useSelector} from "react-redux";

import {ContextNodeAutoSelect} from "./ContextNodeAutoSelect";

export const UserOrgContextNodeAutoSelect = props => {
    const organizationId = useSelector(state => state.userState.user.organizationId);

    return <ContextNodeAutoSelect
        Value={props?.Value}
        UserRoleId={props?.UserRoleId || null}
        OnUpdate={props?.OnUpdate}
        OrganizationId={organizationId}
    />
};


